import InputsButton from "./inputs-button-container";

export default InputsButton;
